import { createContext } from "react";
const cardContext = createContext({
  hasFocus: false,
  hasHover: false
});
export {
  cardContext
};
